import {
  Automations,
  Binoculars,
  Devops,
  File,
  PlaybookAlert,
  Reporting,
  Sparkle,
  Target,
  Users,
  Rule,
} from '@sweep-io/sweep-design/dist/icons';
import { appRoutes } from '../../../../constants/appRoutes';
import House from '../icons/House.svg?react';
import Cube from '../icons/Cube.svg?react';
import Flows from '../icons/Flows.svg?react';
import Chats from '../icons/Chats.svg?react';
import ImpactAnalysis from '../icons/ImpactAnalysis.svg?react';
import { MainMenuItem, MenuColumn } from './types';
import Megaphone from '../../Megaphone.svg?react'; //temporary icon, TODO add to design system
import { colors } from '@sweep-io/sweep-design';

enum AppsMenuSections {
  Analyze = 'Analyze',
  Optimize = 'Control',
  GTMHub = 'GTM Hub',
  AddOns = 'Add ons',
}

const iconColor = colors.blue[500];

//waiting for proper definition from product
export const analyseAppsMenu: MenuColumn[] = [
  {
    columnId: AppsMenuSections.Analyze,
    //no columnLabel here on purpose
    menuItems: [
      {
        label: 'Documentation',
        icon: <Binoculars color={iconColor} />,
        route: appRoutes.documentation.route,
        withEnvSuffix: true,
      },
      {
        label: 'SF Change Feed',
        icon: <File color={iconColor} />,
        route: appRoutes.sfChangeFeed.route,
      },
    ],
  },
];

export const buildAppsColumns: MenuColumn[] = [
  {
    columnLabel: AppsMenuSections.Optimize,
    columnId: AppsMenuSections.Optimize,
    menuItems: [
      {
        label: 'Automations',
        icon: <Automations color={iconColor} />,
        route: appRoutes.automations.route,
        withEnvSuffix: true,
      },
      {
        label: 'Dedupe & Matching',
        icon: <Target color={iconColor} />,
        route: appRoutes.dedup.route,
        withEnvSuffix: true,
      },
      {
        label: 'Rollups',
        icon: <Rule color={iconColor} />,
        route: appRoutes.rollups.route,
        withEnvSuffix: true,
      },
      {
        label: 'Compare & Deploy',
        icon: <Devops color={iconColor} />,
        route: appRoutes.devopsCenter.route,
      },
      {
        label: 'Reporting',
        icon: <Reporting color={iconColor} />,
        route: appRoutes.reports.route,
      },
    ],
  },
  {
    columnLabel: AppsMenuSections.GTMHub,
    columnId: AppsMenuSections.GTMHub,
    menuItems: [
      {
        label: 'Routing',
        icon: <Users color={iconColor} />,
        route: appRoutes.routing.route,
        withEnvSuffix: true,
      },
      {
        label: 'Alerts',
        icon: <PlaybookAlert color={iconColor} />,
        route: appRoutes.alerts.route,
        withEnvSuffix: true,
      },
      {
        subMenuId: AppsMenuSections.AddOns,
        label: 'Add ons',
        icon: <></>,
        route: 'add-ons', //doesn't have a real route
        subMenuItems: [
          {
            label: 'Marketing Management',
            icon: <Megaphone color={iconColor} />,
            route: appRoutes.marketingManagement.route,
          },
          {
            label: 'User Support Agent',
            icon: <Sparkle color={iconColor} />,
            route: appRoutes.aiAssistant.route,
          },
        ],
      },
    ],
  },
];

export const mainMenuItems: MainMenuItem[] = [
  {
    label: 'Home',
    Icon: <House />,
    route: appRoutes.getStarted.route,
  },
  {
    label: 'Visual Workspace',
    Icon: <Flows />,
    route: appRoutes.funnelMapsPage.route,
  },
  {
    label: 'Impact Analysis',
    Icon: <ImpactAnalysis />,
    route: 'apps1', //doesn't have a real route
    menuColumns: analyseAppsMenu,
  },
  {
    label: 'Build',
    Icon: <Cube />,
    route: 'apps2', //doesn't have a real route
    menuColumns: buildAppsColumns,
  },
  {
    label: 'Agentic Layer',
    Icon: <Chats />,
    route: appRoutes.agenticLayer.route,
  },
];
